import React from "react";
import styled from "styled-components";
import { Frame, TextArea } from "./styles";
import Tail from "./Tail";
import { useWindowSize } from "@src/utils/useWindowSize";
import settings from "@src/settings";
import VoiceLead from "@src/components/VoiceLead";
import VoiceIntroImage from "@src/components/VoiceIntroImage";
import { GatsbyImageProps } from "gatsby-plugin-image";

export interface Props {
	direction: "fromRight" | "fromLeft" | "fromTop";
	voiceNumber: number;
	voiceType: string;
	lead: string;
	staffInfo: {
		name: string;
		position: string;
		ruby: string;
	}[];
	img:
		| React.ReactElement<HTMLImageElement>
		| React.FunctionComponent<GatsbyImageProps>;
	onClick?: () => void;
	className?: string;
}

const VoiceItem: React.FC<Props> = (props) => {
	const {
		direction,
		lead,
		voiceNumber,
		voiceType,
		staffInfo,
		img,
		onClick,
		className,
	} = props;
	const { width: windowW } = useWindowSize();
	const directionDefined =
		!windowW || windowW > settings.breakpoint.lg ? direction : "fromTop";
	return (
		<Frame direction={directionDefined} className={className} onClick={onClick}>
			<VoiceIntroImage img={img} />
			<TextArea>
				<VoiceLead
					lead={lead}
					voiceNumber={voiceNumber}
					voiceType={voiceType}
					staffInfo={staffInfo}
					isListItem={true}
				/>
				<Tail direction={directionDefined} />
			</TextArea>
		</Frame>
	);
};

export default styled(VoiceItem)``;
